// shared/domain/fotoProductor.js  (reglas puras: foto del productor a partir de sus parcelas)

/** URL absoluta de un archivo relativo del backend: base sin "/" final + ruta sin "/" inicial. */
export const urlFoto = (baseUrl, ruta) => `${String(baseUrl || '').replace(/\/+$/, '')}/${String(ruta).replace(/^\/+/, '')}`;

/** Primera `newest_foto` no vacía de las parcelas (ruta relativa) o null. Tolera null/no-array. */
export const fotoDeParcelas = parcelas => {
  if (!Array.isArray(parcelas)) return null;
  const parcela = parcelas.find(p => p && typeof p.newest_foto === 'string' && p.newest_foto.trim() !== '');
  return parcela ? parcela.newest_foto.trim() : null;
};
